import React, {Component} from 'react';
import {Route} from 'react-router-dom';
import {connect} from 'react-redux';
import {logout} from '../../config/redux/actions/securityActions';
import AppBarCustom from '../../screens/components/AppBar';
//========== MD SIDEBAR ==========
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import classNames from 'classnames';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ItemExpansion from '../../screens/components/ItemExpansion';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import {withRouter} from 'react-router-dom';
//==============================
import Tooltip from '@material-ui/core/Tooltip';






//security
import SecurityProfile from '../../screens/modules/security/SecurityProfile';
import SecurityProfile2 from '../../screens/modules/security/SecurityProfile2';
import LoginPage2 from '../../screens/modules/security/LoginPage2';
//-----------------------------------------



const drawerWidth = 70;
const styles = theme =>({
   
    
    root: {
        display: 'flex',
        backgroundRepeat  : 'repeat',
       backgroundPosition: 'center',
        
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 8px',
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
        backgroundColor:'#A11B39',

    },
    drawerHeader2: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 8px',
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
        
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing.unit * 3,
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    }
});

 class DashboardPage extends Component{
    constructor(props){
        super(props);

        this.handleDrawerClose = this.handleDrawerClose.bind(this);
        this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
        this.logout = this.logout.bind(this);

        this.state = {
            open: this.props.user.userData.tipo==1 ? true: false
        };
    }

    handleDrawerOpen(){
        this.setState({ open: true });
    }
    
    handleDrawerClose() {
        this.setState({ open: false });
    }
    
    logout(event){
        sessionStorage.clear();
        this.props.logout();
    }    

    render(){
        const {classes, theme, user, history} = this.props;
        const {open} = this.state;


        
        let colorI;
        
        if(user.userData.IdUsuario==453){
          colorI='#A02142';
        }else if(user.userData.IdUsuario==452){
          colorI='#06B6D4'
        }else if(user.userData.IdUsuario==458){
            colorI='#F6025C'
        }else if(user.userData.IdUsuario==451){
          colorI='#731228'
        }else if(user.userData.IdUsuario==448){
          colorI='#41AB34'
        }else if(user.userData.IdUsuario==450){
          colorI='#318e25'
        }
        else{
          colorI='#A02142';
        }

        return(
            <div className={classes.root}>

                <AppBarCustom handleMenu={this.handleMenu}
                  open={this.state.open}
                  handleDrawerOpen={this.handleDrawerOpen}
                  logout={this.logout}
                  userName={user.userData.Usuario}
                  user={user.userData}
                  />
                
                <Drawer className={classes.drawer}
                  variant="persistent"
                  anchor="left"
                  open={open}
                  classes={{paper: classes.drawerPaper}}>
                     <div className={classes.drawerHeader} style={{backgroundColor:colorI}}>
                     <Tooltip title="CERRAR MENU" placement="right">
                        <IconButton onClick={this.handleDrawerClose} style={{color:'white'}}>
                            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton>
                        </Tooltip>
                    </div>
                    <Divider />
                    <Tooltip title="CARTILLAS" placement="right">
                    <ListItem button onClick={(event) => history.push('/cartillas')}>
                        <ListItemIcon style={{marginLeft: 10}}>
                            <i className={'fa fa-user'} style={{ fontSize: '1.5em',color: '#A02142' }} />
                        </ListItemIcon>

                      
                        
                    </ListItem>
                    </Tooltip>
                    {user.userData.tipo==1 ? <Tooltip title="CITAS" placement="right">
                  <ListItem button onClick={(event) => history.push('/cartillas/citas')}>
                        <ListItemIcon style={{marginLeft: 10}}>
                            <i className={'fa fa-calendar'} style={{ fontSize: '1.5em',color: '#A02142' }} />
                        </ListItemIcon>

                      
                        
                    </ListItem>
                    
                    </Tooltip>: null}
                    {/*
                                {user.userData.tipo==1 ? <ListItem button onClick={(event) => history.push('/cartillas/citas')}>
                        <ListItemIcon style={{marginLeft: 10}}>
                            <i className={'fa fa-calendar'} style={{ fontSize: '1.5em',color: '#A02142' }} />
                        </ListItemIcon>

                      
                        
                    </ListItem>: null}
                    <ListItem button onClick={(event) => history.push('/negocios/refrendos')}>
                        <ListItemIcon style={{marginLeft: 15}}>
                            <i className={'fa fa-user'} style={{ fontSize: '1.5em',color: '#A02142' }} />
                        </ListItemIcon>

                        <ListItemText disableTypography
                            primary={<Typography type="body2" style={{ color: '#A02142' }}>Refrendos</Typography>}
                        />

                        
                    </ListItem>
        */ }
                    {/* 
                    <ListItem button onClick={(event) => history.push('/refrendos')}>
                        <ListItemIcon style={{marginLeft: 15}}>
                            <i className={'fas fa-check-square'} style={{ fontSize: '1.5em' }} />
                        </ListItemIcon>

                        <ListItemText disableTypography
                            primary={<Typography type="body2" style={{ color: '#000' }}>Refrendos</Typography>}
                        />
      
                    </ListItem>
                   */}

                    <div style={{display:'flex', flex: 1}}/>
                    {
                           <Tooltip title="CERRAR SESIÓN" placement="right">
                    <ListItem button onClick={() => this.logout()} >
                        <ListItemIcon style={{marginLeft: 15}}>
                            <i className={'fa fa-arrow-circle-right'} style={{ fontSize: '1.5em' , color: colorI}} />
                        </ListItemIcon>
                      
                    </ListItem>
                    </Tooltip>
                    }
                </Drawer>
                <main className={classNames(classes.content, {
                  [classes.contentShift]: open,
                })}>
                    <div className={classes.drawerHeader2} />
                    <Route exact path="/cartillas" component={() => (<SecurityProfile userName={this.props.user.userData.Usuario} />)} />
                    <Route exact path="/cartillas/citas" component={() => (<SecurityProfile2 userName={this.props.user.userData.Usuario} />)} />
                    <Route exact path="/citas" component={() => (<LoginPage2 userName={this.props.user.userData.Usuario} />)} />
                    <Route exact path="/" component={() => (<SecurityProfile2 userName={this.props.user.userData.Usuario} />)} />

                   {/* <Route path='/negocios/detalle2' component={ DetalleOficio2 } /> */}


               

                </main>
            </div>
        );
    }
}

DashboardPage.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state, props) => {
    return {
      user: state.security,
    };
};
const mapDispatchToProps = {
    logout
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(DashboardPage)));